export default __webpack_public_path__ + "static/media/BE.3b99a3e2.svg";